import { ApplicationConfig } from '@angular/core';

import { provideAgileApp } from '@app-config';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAgileApp({ routes, menuParams: { menuProduct: 'APASONE' } })
    ]
};
